import { Action } from '@ngrx/store'

import { Authenticate, AuthResponse } from './../models/auth'

export const LOGIN = '[AUTH] Login'
export const LOGIN_SUCCESS = '[AUTH] Login Success'
export const LOGIN_FAILURE = '[AUTH] Login Failure'

export const LOGIN_REDIRECT = '[AUTH] Login Redirect'

export const LOGOUT = '[AUTH] Logout'

export const AUTHORIZE = '[AUTH] Authorize'
export const SET_TOKEN = '[AUTH] Set Token'

export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: Authenticate) {}
}
export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: AuthResponse) {}
}
export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE;
  constructor(public payload: any) {}
}

export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
  constructor(public payload: string | null) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
}

export class Authorize implements Action {
  readonly type = AUTHORIZE;
}

export class SetToken implements Action {
  readonly type = SET_TOKEN
  constructor(public payload: string) {}
}

export type Actions =
  LoginRedirect
  | Login
  | LoginSuccess
  | LoginFailure
  | Logout
  | Authorize
  | SetToken
